// --------------------------------------------------------
// LabelInput - LabelInput
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { InfoOutlined, HelpOutline } from "@mui/icons-material";
import { useEffect, useState } from "react";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import { Text, TextErr } from "../UI/generalLayout/Layout.styled";
import {
  ContainerInputBorderFull,
  InputBoderFullObrigatory,
  InputBorderFull,
} from "./LabelInputBorderFullEmail.style";

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// LabelInput INTERFACE
// --------------------------------------------------------

interface ILabelInputBorderFull {
  placeholder?: any;
  label?: any;
  disabled?: boolean;
  value: any;
  onChangeText: any;
  isMandatory?: boolean;
  isInvalid?: boolean;
  name: string;
  type: string;
  msgError: string[];
  max: number;
  style?: any;
}

/**
/**
 * A component that renders a input field with a label and placeholders.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const LabelInputBorderFull = ({
  style = {},
  name,
  value,
  placeholder = "",
  label = "",
  disabled,
  onChangeText,
  isMandatory,
  isInvalid,
  msgError,
  max,
  type,
}: ILabelInputBorderFull) => {
  // --------------------------------------------------------
  // LabelInput PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo();

  const [valueTel, setValueTel] = useState("");

  function masktel() {
    let v: any = value;
    setTimeout(() => {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
      v = v.replace(/(\d)(\d{4})$/, "$1-$2");
      setValueTel(v);
    }, 1);    
  }

  useEffect(() => {
    if (type === "tel") {
      masktel();
    }
  }, [value]);

  function disablePaste(event: any) {
    event.preventDefault();
    //alert('Colar não é permitido neste campo.');
  }

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      <ContainerInputBorderFull>
        {/* LABEL DA INPUT */}
        <Text bold={true}>
          {label}{" "}
          <InputBoderFullObrigatory isMandatory={isMandatory}>
            {isMandatory ? "*" : ""}
          </InputBoderFullObrigatory>
        </Text>
        <div style={{ display: "flex" }}>
          {/* INPUT */}
          <InputBorderFull
            name={name}
            type={type}
            id={name}
            value={type !== "tel" ? value : valueTel}
            onChange={onChangeText}
            readOnly={disabled}
            isMobile={isMobile}
            isValid={isInvalid}
            placeholder={placeholder}
            maxLength={max > 0 ? max : Infinity}
            style={style}
            onPaste={disablePaste}
          />

          {/* ICON HELP / INFO */}
          <div style={{ position: "relative", right: "30px", top: "5px" }}>
            {!isInvalid && <InfoOutlined sx={{ color: "#FDA29B" }} />}
          </div>
        </div>
        {!isInvalid && (
          <>
            {msgError?.map((err, index) => (
              <TextErr key={index}>{err}</TextErr>
            ))}
          </>
        )}
      </ContainerInputBorderFull>
    </>
  );
  // --------------------------------------------------------
};

export default LabelInputBorderFull;
